// extracted by mini-css-extract-plugin
export var icon = "_as-3";
export var subtitle = "_as-2";
export var title = "_as-1";
export var value = "_as-0";